export default __webpack_public_path__ + "static/1413-8f4e9d2312e7195b83f083bad5c6cf32.gif";